import React, { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { routes } from "./Routes";
import Layout from "./Layout";
import { store } from "./store";
import { useSelector } from "react-redux";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "react-query";
// import { getToken } from "firebase/messaging";
// import { onMessageListener } from "./firebase";

function App() {
  // const [show, setShow] = useState(false);
  // const [notification, setNotification] = useState({ title: "", body: "" });
  // const [isTokenFound, setTokenFound] = useState(false);
  // const [theme, setTheme] = React.useState(false);
  const theme = useSelector((state) => state.themeMode);
  const mode = createTheme({
    palette: {
      mode: theme ? "dark" : "light",
      primary: {
        main: "#800120",
      },
    },
  });

  // getToken(setTokenFound);

  // onMessageListener()
  //   .then((payload) => {
  //     setShow(true);
  //     setNotification({
  //       title: payload.notification.title,
  //       body: payload.notification.body,
  //     });
  //     console.log(payload);
  //   })
  //   .catch((err) => console.log("failed: ", err));

  const queryClient = new QueryClient();
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={mode}>
          <Provider store={store}>
            <BrowserRouter>
              <Routes>
                {routes.map((routes) => {
                  return (
                    <Route
                      key={routes.id}
                      path={routes.path}
                      element={<Layout component={routes.element} />}
                    />
                  );
                })}
              </Routes>
            </BrowserRouter>
          </Provider>
        </ThemeProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
